import {ReactElement} from "react";
import {Box} from '@chakra-ui/react';

export const opwPart1Q4AText: ReactElement = (
    <>
        Are you a 'small' entity for the purposes of the IR35 rules?
        Broadly this means meeting two of the following criteria in two consecutive financial years:
        <Box display="flex" justifyContent="center" pt="1rem" pl="2rem">
            <ul>
                <li>Annual turnover less than &#163;10.2m (*&#163;15m)</li>
                <li>Balance sheet total not more than &#163;5.1m (*&#163;7.5m)</li>
                <li>No more than 50 employees on average</li>
                <li>*New threshold from April 2025</li>
            </ul>
        </Box>
    </>
);